import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=b8ab1666&scoped=true"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ab1666",
  null
  
)

export default component.exports